function* applyBatchActions({ payload }, handlers) {
  const batchedActions = [].concat(payload);

  for (const action of batchedActions) {
    for (const [handlerKey, handler] of Object.entries(handlers)) {
      if (action.type === handlerKey) {
        yield handler(action);
      }
    }
  }
}

export default applyBatchActions;
